import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Modal } from "antd";
import {
  EyeOutlined,
  HeartFilled,
  HeartOutlined,
  HeartTwoTone,
  ShareAltOutlined,
} from "@ant-design/icons";
import { BlankSpace, PageContainer } from "../../../component/Xcomponent";
import BookmarkIcon from "@material-ui/icons/Bookmark";
import BookmarkBorderOutlinedIcon from "@material-ui/icons/BookmarkBorderOutlined";
import { Link, useLocation } from "react-router-dom";
import moment from "moment";
import { connect } from "react-redux";

import {
  ArticleCard,
  ArticleImage,
  ArticleTitle,
  ArticleViews,
  Description,
  LeftBlock,
  LikeBlock,
  RightBlock,
  ViewBlock,
  ShareBlock,
  BookmarkBlock,
} from "./ArticleViewStyle";

import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";
import { FaCopy } from "react-icons/fa";
/* actions */
import {
  getArticleBySlug,
  getArticleBySlugReset,
} from "../../../action/getArticleBySlugAction";
import {
  saveArticleLike,
  saveArticleLikeReset,
} from "./../../../action/saveArticleLikeAction";
import {
  saveArticleBookmark,
  saveArticleBookmarkReset,
} from "./../../../action/saveArticleBookmarkAction";

import { s3_cdn } from "../../../utils";

// Icons
import { DotIcon } from "../../../component/CustomIcons";
import AudioArticle from "../../../component/AudioArticle/AudioArticle";
import VideoArticle from "../../../component/VideoArticle/VideoArticle";
import ImageArticle from "../../../component/ImagesArticle/ImagesArticle";
import HeaderContext from "../../../context/HeaderContext";

export const ArticleView = (props) => {
  /* variables */
  const {
    getArticleBySlug,
    getArticleBySlugReset,
    getArticleBySlugState,
    saveArticleLike,
    saveArticleBookmark,
    saveArticleBookmarkReset,
  } = props;
  const slug = props.match.params.slug;
  const [articleParams, setArticleParams] = useState({
    slug: slug,
  });
  const location = useLocation();

  // Callback
  const [click, setclick] = useState({
    liked: false,
    bookmark: false,
  });
  const [ArticleData, setArticleData] = useState({
    id: "",
    title: "",
    Description: "",
    img: "",
    views: "",
    likes: "",
    type: "",
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [copied, setCopied] = useState(false);
  const {setTitle} = useContext(HeaderContext);
  setTitle("Blogs");
  const toggle = (value) => {
    if (value === "liked" && localStorage.getItem("LilacDoctorToken")) {
      let clicked = click.liked;
      console.log(getArticleBySlugState);
      const data = {
        article_id: getArticleBySlugState.data._id,
      };
      clicked = !clicked;
      if (clicked === true) {
        getArticleBySlugState.data.likes = getArticleBySlugState.data.likes + 1;
        saveArticleLike(data);
        console.log(data);
      } else {
        getArticleBySlugState.data.likes = getArticleBySlugState.data.likes - 1;
        saveArticleLike(data);
        console.log("ELSE");
      }
      setclick({ ...click, ["liked"]: clicked });
    } else if (
      value === "bookmark" &&
      localStorage.getItem("LilacDoctorToken")
    ) {
      let clicked1 = click.bookmark;
      clicked1 = !clicked1;
      const data1 = {
        article_id: getArticleBySlugState.data._id,
      };
      console.log(data1);
      saveArticleBookmark(data1);
      setclick({ ...click, ["bookmark"]: !click.bookmark });
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const copy = () => {
    const el = document.createElement("input");
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    setCopied(true);
  };

  useEffect(() => {
    getArticleBySlug(articleParams);
    return () => {
      getArticleBySlugReset();
    };
  }, []);

  useEffect(() => {
    if (getArticleBySlugState.apiState === "success") {
      setArticleData({
        ["id"]: getArticleBySlugState.data._id,
        ["title"]: getArticleBySlugState.data.title,
        ["Description"]: getArticleBySlugState.data.description,
        ["img"]: getArticleBySlugState.data.image_path,
        ["views"]: getArticleBySlugState.data.views,
        ["likes"]: getArticleBySlugState.data.likes,
        ["type"]: getArticleBySlugState.data.type,
        ["audio_path"]: getArticleBySlugState.data.audio_path,
        ["video_path"]: getArticleBySlugState.data.video_path,
        ["video_link"]: getArticleBySlugState.data.video_link,
      });
      console.log(getArticleBySlugState, "getArticleBySlugState");
      setclick({
        ["liked"]: getArticleBySlugState.data.meta.liked,
        ["bookmark"]: getArticleBySlugState.data.meta.bookmarked,
      });
    }
  }, [getArticleBySlugState]);

  console.log("Article Data", ArticleData);
  const renderArticleType = () => {
    console.log(ArticleData.type);
    if (ArticleData.type == "Audio Article") {
      return <AudioArticle ArticleData={ArticleData} />;
    } else if (ArticleData.type == "Text Article") {
    } else if (ArticleData.type == "Video Article") {
      return <VideoArticle ArticleData={ArticleData} />;
    } else {
      return null;
    }
  };

  const renderArticleImage = () => {
    if (ArticleData.type == "Text Article") {
      return <ImageArticle type={"text"} />;
    } else if (ArticleData.type == "Audio Article") {
      return <ImageArticle type={"audio"} />;
    } else {
      return null;
    }
  };

  window.scrollTo(0, 0);
  return (
    <PageContainer className=" ml-n3 mr-n3 ml-sm-0 mr-sm-0">
      <ArticleTitle>{getArticleBySlugState.data.title}</ArticleTitle>
      <BlankSpace />
      {ArticleData.type == "Audio Article" ? (
        <>
          <Row
            className="article-row"
            gutter={[24, 24]}
            style={{
              padding: "1px",
              marginLeft: "1px",
              marginRight: "1px",
            }}
          >
            <Col className="col-sm-12 col-md-12 col-lg-4 text-center p-0">
              <div
                className="p-2 p-sm-3"
                style={{
                  boxShadow: "0px 8px 18px rgba(202, 212, 226, 0.5)",
                  maxHeight: "330px",
                }}
              >
                {renderArticleImage()}
                {ArticleData.type == "Audio Article" ? (
                  <AudioArticle ArticleData={ArticleData} />
                ) : null}
              </div>
            </Col>

            <Col
              className="views-like-bookmark"
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={16}
            >
              <ArticleViews className="Article starts">
                <Col
                  className="views-like"
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                >
                  <LeftBlock>
                    <ViewBlock style={{ paddingRight: "15px" }}>
                      <EyeOutlined
                        className="notificationIcon"
                        style={{ display: "inline-flex" }}
                      />{" "}
                      {getArticleBySlugState.data.views}{" "}
                      {getArticleBySlugState.data.views < 2 ? "view" : "views"}
                    </ViewBlock>
                    <LikeBlock onClick={() => toggle("liked")}>
                      {click.liked ? (
                        <>
                          <HeartFilled
                            className="notificationIcon"
                            style={{ color: "#eb2f96", display: "inline-flex" }}
                          />{" "}
                          {getArticleBySlugState.data.likes}{" "}
                          {getArticleBySlugState.data.likes < 2
                            ? "like"
                            : "likes"}{" "}
                        </>
                      ) : (
                        <>
                          <HeartTwoTone
                            className="notificationIcon"
                            twoToneColor="#eb2f96"
                            style={{ display: "inline-flex" }}
                          />{" "}
                          {getArticleBySlugState.data.likes}{" "}
                          {getArticleBySlugState.data.likes < 2
                            ? "like"
                            : "likes"}{" "}
                        </>
                      )}
                    </LikeBlock>
                  </LeftBlock>
                </Col>
                <Col
                  style={{ textAlign: "right" }}
                  className="bookmark"
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                >
                  <RightBlock>
                    <ShareBlock>
                      <ShareAltOutlined
                        onClick={showModal}
                        style={{ display: "inline-flex" }}
                      />
                    </ShareBlock>
                    <BookmarkBlock onClick={() => toggle("bookmark")}>
                      {click.bookmark ? (
                        <>
                          <BookmarkIcon></BookmarkIcon>
                          {/* <i class="fa fa-bookmark"></i> */}
                        </>
                      ) : (
                        <>
                          <BookmarkBorderOutlinedIcon></BookmarkBorderOutlinedIcon>
                          {/* <i class="fa fa-bookmark-o"></i> */}
                        </>
                      )}
                    </BookmarkBlock>
                  </RightBlock>
                </Col>
              </ArticleViews>
              <BlankSpace />
              <Col
                className="description p-0"
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
              >
                <Description
                  dangerouslySetInnerHTML={{
                    __html: decodeURIComponent(
                      getArticleBySlugState.data.description
                    ),
                  }}
                />
              </Col>
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row
            className="article-row"
            gutter={[24, 24]}
            style={{ padding: "1px", marginLeft: "1px", marginRight: "1px" }}
          >
            <Col
              className="ArticleImage p-0"
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
            >
              {renderArticleImage()}
              {ArticleData.type == "Audio Article" ? (
                <AudioArticle ArticleData={ArticleData} />
              ) : null}
            </Col>
          </Row>
          <BlankSpace />
          <Row gutter={[30, 5]}>
            <Col
              className="article-col pl-0"
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
            >
              {ArticleData.type == "Video Article" ? (
                <VideoArticle ArticleData={ArticleData} />
              ) : null}
            </Col>

            <Col
              className="views-like-bookmark mb-3"
              style={{ paddingLeft: 0 }}
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
            >
              <ArticleViews>
                <Col
                  className="views-like"
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                >
                  <LeftBlock>
                    <ViewBlock className="me-4 px-1">
                      <EyeOutlined
                        className="notificationIcon"
                        style={{ display: "inline-flex" }}
                      />{" "}
                      {getArticleBySlugState.data.views}{" "}
                      {getArticleBySlugState.data.views < 2 ? "view" : "views"}
                    </ViewBlock>
                    <LikeBlock onClick={() => toggle("liked")}>
                      {click.liked ? (
                        <>
                          <HeartFilled
                            className="notificationIcon"
                            style={{ color: "#eb2f96", display: "inline-flex" }}
                          />{" "}
                          {getArticleBySlugState.data.likes}{" "}
                          {getArticleBySlugState.data.likes < 2
                            ? "like"
                            : "likes"}{" "}
                        </>
                      ) : (
                        <>
                          <HeartTwoTone
                            className="notificationIcon"
                            twoToneColor="#eb2f96"
                            style={{ display: "inline-flex" }}
                          />{" "}
                          {getArticleBySlugState.data.likes}{" "}
                          {getArticleBySlugState.data.likes < 2
                            ? "like"
                            : "likes"}{" "}
                        </>
                      )}
                    </LikeBlock>
                  </LeftBlock>
                </Col>
                <Col
                  style={{ textAlign: "right" }}
                  className="bookmark"
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                >
                  <RightBlock className="right block">
                    <ShareBlock>
                      <ShareAltOutlined
                        onClick={showModal}
                        style={{ display: "inline-flex" }}
                      />
                    </ShareBlock>
                    <BookmarkBlock onClick={() => toggle("bookmark")}>
                      {click.bookmark ? (
                        <>
                          <BookmarkIcon></BookmarkIcon>
                          {/* <i class="fa fa-bookmark"></i> */}
                        </>
                      ) : (
                        <>
                          <BookmarkBorderOutlinedIcon></BookmarkBorderOutlinedIcon>
                          {/* <i class="fa fa-bookmark-o"></i> */}
                        </>
                      )}
                    </BookmarkBlock>
                  </RightBlock>
                </Col>
              </ArticleViews>
            </Col>
            <Col
              className="description"
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
            >
              <Description
                dangerouslySetInnerHTML={{
                  __html: decodeURIComponent(
                    getArticleBySlugState.data.description
                  ),
                }}
              />
            </Col>
          </Row>
        </>
      )}
      <Modal visible={isModalVisible} onCancel={handleOk} footer={null}>
        <h3 className="pb-2" style={{ borderBottom: "1px solid #CCC" }}>
          Share
        </h3>
        <div className="container">
          <div className="row">
            <div className="col-12 mt-4 mb-3">
              <div className="row text-center">
                <div className="col-1"></div>
                <div className="col-2 text-center">
                  <FacebookShareButton
                    url={`${window.location.href}`}
                    quote={""}
                    hashtag=""
                  >
                    <FacebookIcon size={36} round={true} />
                  </FacebookShareButton>
                </div>
                <div className="col-2">
                  <LinkedinShareButton
                    url={`${window.location.href}`}
                    quote={""}
                    hashtag=""
                  >
                    <LinkedinIcon size={36} round={true} />
                  </LinkedinShareButton>
                </div>
                <div className="col-2">
                  <TwitterShareButton
                    url={`${window.location.href}`}
                    quote={""}
                    hashtag=""
                  >
                    <TwitterIcon size={36} round={true} />
                  </TwitterShareButton>
                </div>
                <div className="col-2">
                  <WhatsappShareButton
                    url={`${window.location.href}`}
                    quote={""}
                    hashtag=""
                    onShareWindowClose
                  >
                    <WhatsappIcon size={36} round={true} />
                  </WhatsappShareButton>
                </div>
                <div className="col-2">
                  <FaCopy onClick={copy} size={32} round={true} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </PageContainer>
  );
};

const mapStateToProps = (state) => ({
  getArticleBySlugState: state.getArticleBySlug,
  saveArticleLikeState: state.saveArticleLike,
  saveArticleBookmarkState: state.saveArticleBookmark,
});

const mapDispatchToProps = (dispatch) => ({
  getArticleBySlug: (params) => dispatch(getArticleBySlug(params)),
  getArticleBySlugReset: () => dispatch(getArticleBySlugReset()),
  saveArticleLike: (params) => dispatch(saveArticleLike(params)),
  saveArticleBookmark: (params) => dispatch(saveArticleBookmark(params)),
  saveArticleBookmarkReset: () => dispatch(saveArticleBookmarkReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArticleView);
